import { UploadSource, UploadVersion } from '@office-start/upload-types';
import { getParamFromWindow } from '@office-start/window-utility';
var PartnerCorrelationIdQueryParameterName = 'partnerCid';
export var getCommonTelemetryParams = function (source, version) {
    var params = {};
    var partnerCorrelationId = getParamFromWindow(PartnerCorrelationIdQueryParameterName);
    if (source !== undefined)
        params["ItemCategory" /* InstrumentationParam.ItemCategory */] = UploadSource[source];
    if (version !== undefined)
        params["Version" /* InstrumentationParam.Version */] = UploadVersion[version];
    if (partnerCorrelationId) {
        params["PartnerCorrelationId" /* InstrumentationParam.PartnerCorrelationId */] =
            partnerCorrelationId;
    }
    return params;
};
//# sourceMappingURL=getCommonTelemetryParams.js.map